export var loaDetailsMapper = function (data) {
    var result = {
        acCode: "",
        relative_NAME: "",
        relation: "",
        panno: "",
        email: "",
        fileName: "",
        data: undefined,
        acName: "",
        eqbse: "",
        eqnse: "",
        eqmsei: "",
        fobse: "",
        fonse: "",
        fomsei: "",
        currencybse: "",
        currencynse: "",
        currencymsei: "",
        mcx: "",
        ncdex: "",
        neml: "",
        mobileNo: "",
        databytes: undefined,
        userId: undefined,
        companyName: "",
    };
    if (data) {
        return {
            acCode: data.acCode,
            relative_NAME: data.relative_NAME,
            relation: data.relation,
            panno: data.panno,
            email: data.email,
            fileName: data.fileName,
            data: data.data,
            acName: data.acName,
            eqbse: data.eqbse,
            eqnse: data.eqnse,
            eqmsei: data.eqmsei,
            fobse: data.fobse,
            fonse: data.fonse,
            fomsei: data.fomsei,
            currencybse: data.currencybse,
            currencynse: data.currencynse,
            currencymsei: data.currencymsei,
            mcx: data.mcx,
            ncdex: data.ncdex,
            neml: data.neml,
            mobileNo: data.mobileNo,
            databytes: data.databytes,
            userId: data.userId,
            companyName: data.companyName,
        };
    }
    return result;
};
